<div class="campaign-countdown-clock-wrapper" *ngIf="countdownClockData">
    <finder-lottie-bg *ngIf="countdownClockData?.bgItems"
        [data]="countdownClockData.bgItems"
        [onTriggerPlayback]="triggerPlayback"
    ></finder-lottie-bg>
    <finder-countdown-clock
        *ngIf="targetMatch"
        [countdownClockData]="countdownClockData"
        [ngClass]="cssClass"
        (clockVisible)="clockVisible($event)"
    ></finder-countdown-clock>
</div>
